import { AUTH } from "./types";

import ActionHelper from "../helpers/ActionHelper";

export const login = (form) => (dispatch) => {
  return ActionHelper.requestServer(
    "POST",
    "/login",
    form,
    AUTH.AUTH_LOGIN_REQUEST,
    AUTH.AUTH_LOGIN_SUCCESS,
    AUTH.AUTH_LOGIN_FAIL,
    dispatch,
  );
};

export const logout = () => (dispatch) => {
  localStorage.removeItem("credentials");
  document.location.href = "/";

  dispatch({
    type: AUTH.AUTH_LOGOUT,
  });
};

export const isValidToken = (token) => (dispatch) => {
  return ActionHelper.requestServer(
    "GET",
    "/is-valid-token?token=" + token,
    null,
    AUTH.AUTH_IS_VALID_TOKEN_REQUEST,
    AUTH.AUTH_IS_VALID_TOKEN_SUCCESS,
    AUTH.AUTH_IS_VALID_TOKEN_FAIL,
    dispatch,
  );
};



// WEBPACK FOOTER //
// ./src/actions/authActions.js